import { Event } from '../Event'
import { Identity } from '../../constants'
import { EngagementChannel } from './types'

export interface EngagementChannelViewedEventProperties {
  engagement_channel: EngagementChannel
  variation: string
  category?: string
}

export class EngagementChannelViewedEvent extends Event<EngagementChannelViewedEventProperties> {
  static displayName = 'Engagement Channel Viewed'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
